// @flow
import ProfileBoardsPage from 'app/common/react/components/profile/ProfileBoards/ProfileBoardsPage';
import withRouteData from 'app/common/lib/react/withRouteData';

export default withRouteData({
  name: 'BoardsList',
  routeContextLog: (context: Object, params: { username: string }) => {
    // This is super hacky but otherwise we need to get the user id from the resource load
    // and this is mostly only used for the own board view log
    let userId;
    if ((context.user || {}).username === params.username) {
      userId = context.user.id;
    }
    return {
      object_id_str: userId,
      view_type: PCONST.thrift.ViewType.USER,
      view_parameter: PCONST.thrift.ViewParameterType.USER_BOARDS,
    };
  },
})(ProfileBoardsPage);
